/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import { FC, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Avatar,
  Box,
  Card,
  Container,
  Divider,
  Grid,
  ImageList,
  ImageListItem,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import AirplanemodeActiveOutlinedIcon from "@mui/icons-material/AirplanemodeActiveOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import { useNavigate, useParams } from "react-router-dom";
import Genders from "models/Enums/Genders";
import classes from "./style";
import { getImageUrl } from "utils/imageUtils";
import userService from "services/userService";
import PublicUser from "models/PublicUser";
import ImagesCarousel from "components/carousel/Carousel";

const UserProfil: FC<{}> = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [user, setUser] = useState<PublicUser | undefined>(undefined);
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('lg'));
  const [selectedImage, setSelectedImage] = useState<any>(null);

  useEffect(() => {
    const getUser = async () => {
      let u = await userService.getPublic(id);

      if (u !== undefined && u !== null) {
        setUser(u);
      } else {
        navigate('');
      }
    }

    getUser();
  }, [id]);

  return (
    user && (<>
      <Container sx={{ ...classes.emptyPasseport, ...classes.noMouse }}>
        <Typography variant="h1" my={5}>
          PASSEPORT
        </Typography>

        <Grid container sx={{ ...classes.messagerie, ...classes.noMouse }} my={3} pb={!isMd ? 3 : 0}>
          <Grid item xs={12} md={6} lg={3} sx={{ ...classes.profileBloc, ...classes.noMouse }}>
            <Box sx={{ position: "relative" }}>
              <Avatar
                sx={classes.profileAvatar}
                alt={`${user.firstName} ${user.lastName}`}
                src={getImageUrl(user.profilePicture)}
              />
              <Box sx={classes.uploadAvatar}>
                <AddAPhotoIcon />
              </Box>
            </Box>

          </Grid>
          <Grid item xs={12} md={6} lg={5}>
            <Card>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Box>
                  <Typography component="div" variant="h5">
                    {`${user.lastName}, ${(user.firstName?.length > 0 ? String(user.firstName).charAt(0).toUpperCase() : '')}`}
                  </Typography>
                  <Typography component="div" variant="body2">
                    {`${
                      // eslint-disable-next-line no-nested-ternary
                      Genders[user.gender] === "Male"
                        ? "Homme"
                        : Genders[user.gender] === "Female"
                          ? "Femme"
                          : "Autre"
                      }, ${user.age} ans`}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ ...classes.noMouse }}>
                <List dense>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <MapOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Destinations"
                      secondary={user.pastTravels?.join(" , ")}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <AirplanemodeActiveOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Moyens de transport"
                      secondary={user.favoriteTransports?.join(" , ")}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <SportsBasketballOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Ambiance"
                      secondary={user.favoriteStayTypes?.join(" , ")}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <MapOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Description"
                      secondary={user.description}
                    />
                  </ListItem>
                </List>
              </Box>
            </Card>
          </Grid>
          {user.personalPictures.length > 0 &&
            <Grid item xs={12} lg={4} sx={!isMd ? null : classes.imageListBloc}>
              <ImageList variant="quilted" cols={2} sx={{ minHeight: '100px' }}>
                {[0, 1, 2].map((item, i) => (
                  <ImageListItem key={item.toString()} cols={i == 0 ? 2 : 1} rows={1}>
                    {
                      user.personalPictures.length > i ?
                        <img src={getImageUrl(user.personalPictures[i])} width="100%" height="100%"
                          loading="lazy" onClick={() => setSelectedImage({ img: getImageUrl(user.personalPictures[i]), title: user.personalPictures[i] })} />
                        :
                        <Skeleton variant="rectangular" width="100%" height="100%" />
                    }
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          }
        </Grid>
      </Container>
      {
        user.personalPictures?.length > 0 ?
          <ImagesCarousel
            open={selectedImage ? true : false}
            images={user.personalPictures.map((i) => {
              return {
                img: getImageUrl(i),
                title: i,
              };
            })}
            selectedImage={selectedImage}
            handleClose={() => {
              setSelectedImage(null);
            }}
          /> : ''
      }
    </>
    )
  );
};

export default UserProfil;
